export const convertDigitsToArabicNumerals = (digits: string): string => {
	// Convert digits to Arabic numerals
	return digits.replace(/\d/g, d => "٠١٢٣٤٥٦٧٨٩"[parseInt(d, 10)]);
};
